module.exports = __webpack_public_path__ + "static/img/data_deletion_2.b54847b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_11_23/data_deletion_2.png
// module id = R+sG
// module chunks = 1